__webpack_require__.p = "/travel-journal/";